import React from 'react';
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom';

import * as Sentry from '@sentry/react';

let sentryCreateBrowserRouter = createBrowserRouter;

export const initializeSentry = ({
  enableTracing = false,
  enableReplays = false,
  enableFeedback = false,
  enableProfiling = false,
  user
}) => {
  if (Sentry.isInitialized) return;
  const integrations = [];

  if (enableTracing) {
    sentryCreateBrowserRouter =
      Sentry.wrapCreateBrowserRouter(createBrowserRouter);
    integrations.push(
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      })
    );
  }

  if (enableReplays) {
    integrations.push(Sentry.replayIntegration());
  }

  let feedback;
  if (enableFeedback) {
    feedback = Sentry.feedbackIntegration({
      isEmailRequired: true,
      autoInject: false,
      showName: false,
      showEmail: false,
      useSentryUser: {
        name: 'fullName',
        email: 'email'
      }
    });
    integrations.push(feedback);
  }

  if (enableProfiling) {
    integrations.push(Sentry.browserProfilingIntegration());
  }

  Sentry.setUser(user);

  Sentry.init({
    dsn: 'https://eab10ccf5d84cece6c85b58d4bc74094@o4508064831766528.ingest.de.sentry.io/4508064838451280',
    integrations,
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', 'https://portal.bohsa.co.uk'],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    profilesSampleRate: 1.0
  });
};

export { Sentry, sentryCreateBrowserRouter };
